// extracted by mini-css-extract-plugin
export default {"card":"settings-step_card__8baUf","grid":"settings-step_grid__NXIas"};